import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <div class="admin-root">
      <aside class="sidebar">
        <div class="sidebar-brand">
          <div class="brand-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M12 12h.01"/><path d="M17 12h.01"/><path d="M7 12h.01"/></svg>
          </div>
          <div>
            <h1>Kiosk Admin</h1>
            <span>Panel de gestión</span>
          </div>
        </div>

        <div class="sidebar-section-label">NAVEGACIÓN</div>
        <nav>
          <a routerLink="/admin" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            <span>Clientes</span>
          </a>
          <a routerLink="/admin/leaderboard" routerLinkActive="active">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5C7 4 7 7 7 7"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5C17 4 17 7 17 7"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>
            <span>Leaderboard</span>
          </a>
        </nav>

        <div class="sidebar-bottom">
          <a routerLink="/" class="back-kiosk">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>
            Volver al kiosko
          </a>
          <div class="version-label">Games Kiosk Admin v1.0</div>
        </div>
      </aside>
      <main class="main-area">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    :host { display: block; height: 100vh; }

    .admin-root {
      display: flex;
      height: 100%;
      background: #f8fafc;
      font-family: 'Inter', system-ui, -apple-system, sans-serif;
      color: #1e293b;
    }

    .sidebar {
      width: 250px;
      min-width: 250px;
      background: #0f172a;
      color: #e2e8f0;
      display: flex;
      flex-direction: column;
    }

    .sidebar-brand {
      padding: 20px 20px 16px;
      display: flex;
      align-items: center;
      gap: 12px;
      border-bottom: 1px solid rgba(255,255,255,0.06);
    }

    .brand-icon {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }

    .sidebar-brand h1 {
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      margin: 0;
      letter-spacing: -0.3px;
    }

    .sidebar-brand span {
      font-size: 11px;
      color: #64748b;
    }

    .sidebar-section-label {
      padding: 20px 20px 8px;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1.2px;
      color: #475569;
    }

    nav {
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    nav a {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      border-radius: 8px;
      color: #94a3b8;
      text-decoration: none;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.15s;
    }

    nav a:hover {
      background: rgba(255,255,255,0.06);
      color: #e2e8f0;
    }

    nav a.active {
      background: rgba(99,102,241,0.15);
      color: #a5b4fc;
    }

    nav a.active svg { stroke: #a5b4fc; }

    nav a svg { stroke: #64748b; transition: stroke 0.15s; }
    nav a:hover svg { stroke: #94a3b8; }

    .sidebar-bottom {
      margin-top: auto;
      padding: 16px;
      border-top: 1px solid rgba(255,255,255,0.06);
    }

    .back-kiosk {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border-radius: 8px;
      color: #64748b;
      text-decoration: none;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.15s;
    }

    .back-kiosk:hover { color: #94a3b8; background: rgba(255,255,255,0.04); }
    .back-kiosk svg { stroke: #64748b; }

    .version-label {
      padding: 8px 12px 0;
      font-size: 10px;
      color: #334155;
    }

    .main-area {
      flex: 1;
      overflow-y: auto;
      padding: 32px 40px;
    }
  `]
})
export class AdminLayoutComponent {}
